export interface ListFilter<T> {
    value: T[];
    filterOperator: ListFilterOperator;
}

export interface TextFilter {
    value: string;
    filterOperator: TextFilterOperator;
}

export interface CustomFieldFilter {
    inputFieldId: string;
    operator: number;
    value: any;
}

export enum ListFilterOperator {
    In = 0,
    NotIn = 1,
}

export enum TextFilterOperator {
    Contains = 0,
    NotContains = 1,
}

// UI-internal operator. The wire format is type-dependent (TextFilterOperator for text fields,
// ListFilterOperator for list fields) — see ContractSqlQueryBuilder.ApplyCustomFieldFilters.
// Conversion happens at the hydration/submission boundaries in ContractFilter.types.ts,
// SystemFilter.types.ts, and filterOperatorHydration.ts.
export enum FilterOperatorUi {
    Positive = 0,
    Negative = 1,
}

export enum SortDirection {
    ASC = 0,
    DESC = 1,
}
